import _ from 'lodash';
import Backbone from 'backbone';
import MediaModel from './mediaModel';
import VideoModel2 from './videoModel2';

const VideoModel = MediaModel.extend({
    urlRoot: '/api/rest/facade/video',
    type: 'video',
    defaults: {
        video: {
            caption: 'Caption is Required',
            externalId: 'provided by vendor',
            thumbUrl: 'thumb url',
            drm: 'Not Currently Used',
            version: '1',
            type: 'Video',
            title: 'Please Add a Title',
            alt: 'Please Alt Tags',
            updatedBy: 'uploader',
            metadata: 'metadata?',
            orderNumber: 999,
            attributes: [
                {
                    name: 'duration',
                    value: 'metadata?',
                },
            ],
        },
        tags: [],
    },
    parse(data) {
        return data.data?.[0] ?? data;
    },
    save(atts, opts) {
        const options = opts || {};
        const attrs = atts || this.attributes;
        const iattrs = attrs.video.attributes;
        this.url = this.urlRoot.replace('/' + this.id, '') + (this.id ? '/' + this.id : '');
        for (const key in iattrs) {
            this.vars[iattrs[key].name] = iattrs[key].value;
        }
        attrs.video.attributes = iattrs;
        Backbone.Model.prototype.save.call(this, attrs, options);
    },
    destroy(options) {
        const opts = Object.assign(
            {
                url: this.urlRoot.replace('/' + this.id, '') + (this.id ? '/' + this.id : ''),
            },
            options || {},
        );
        return Backbone.Model.prototype.destroy.call(this, opts);
    },
    initialize() {
        const attributes = this.attributes.video.attributes;

        this.vars = {};
        this.type = 'video';
        this.id = this.attributes.video.uuid;
        _.each(attributes, attr => {
            this.vars[attr.name] = attr.value;
        });

        return this;
    },
    setModelUrl(url) {
        this.rootUrl = url;
    },
    getModelPropertyValue(propertyName) {
        switch (propertyName) {
            case 'tags':
                return this.attributes.tags;
            default:
                return this.attributes.video[propertyName];
        }
    },
    setModelPropertyValue(propertyValue, propertyName) {
        const attributes = this.attributes.video.attributes;
        let attributeFound = false;
        function setValue(_propertyValue, _propertyName) {
            switch (_propertyName) {
                case 'duration':
                    for (const key in attributes) {
                        if (attributes[key].name === _propertyName) {
                            attributeFound = true;
                            attributes[key].value = _propertyValue;
                        }
                    }
                    if (!attributeFound) {
                        attributes.push({name: _propertyName, value: _propertyValue});
                    }
                    break;
                case 'tags':
                    this.attributes.tags = _propertyValue;
                    break;
                default:
                    this.attributes.video[_propertyName] = _propertyValue;
            }
        }
        if (typeof propertyValue === 'object') {
            for (const key in propertyValue) {
                setValue(propertyValue[key].value, propertyValue[key].property);
            }
        } else {
            setValue(propertyValue, propertyName);
        }
    },

    getTags() {
        return this.getModelPropertyValue('tags');
    },
    setTags(tags) {
        this.attributes.tags = tags;

        return this;
    },
    addTags(tags) {
        const tagArray = [];
        if (Array.isArray(tags)) {
            for (const tag in tags) {
                tagArray.push(tags[tag]);
            }
            this.setModelPropertyValue(tagArray, 'tags');
        }

        return this;
    },
    addTag(tag) {
        this.attributes.tags.push(tag);

        return this;
    },
    removeTags(tags) {
        _.each(tags, this.removeTag);

        return this;
    },
    removeTag(tag) {
        this.attributes.tags = _.reject(this.attributes.tags, tag);

        return this;
    },
    toNewVideoModel() {
        return new VideoModel2().parseFromLegacyJSON(this.toJSON());
    },
});

export default VideoModel;
